import './styles/main.css';
import { initPreloader } from './animations/preloader';
import { initScroll } from './animations/scroll';
import { initMagneticButtons, initButtonHovers } from './animations/hover';
import { initBookingFlow } from './animations/booking';

document.addEventListener('DOMContentLoaded', () => {
  // Start Preloader immediately
  initPreloader();

  // Initialize interactive components
  initMagneticButtons();
  initButtonHovers();
  initBookingFlow();

  // Wait for preloader transition before setting up scroll triggers
  window.addEventListener('preloaderComplete', () => {
    initScroll();
  });
});
